// libraries
import { atom, atomFamily, selector } from 'recoil';

/** GPS 전체 리스트 */
export const GPSWorkerAtomFamily = atomFamily({
  key: 'GPSWorkerAtomFamily',
  default: []
});

/** 선택된 비콘 */
export const SelectedGPSWorkerAtom = atom({
  key: 'SelectedGPSWorkerAtom',
  default: null
});

/** GPS 리스트를 위한 selector */
export const GPSListSelector = selector({
  key: 'GPSListSelector',
  get: ({ get }) => {
    return get(GPSWorkerAtomFamily('all'));
  }
});
